import './public-path.js';

const data = window.sectionData;
data.query = {};

const { searchParams } = new URL(location);

for (const entry of searchParams.entries()) {
	data.query[ entry[0] ] = entry[1];
}

window.sectionResponse = fetch('/loadSection?_framework_ajax=1', {
	method: 'post',
	body: JSON.stringify(data),
	headers: {
		'Content-Type': 'application/json',
	},
}).then(response => response.json());
